export default {
      id: "oc-passthrough-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-passthrough",
      toString: function () {
        return this.url;
      }
    }